var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("iframe", {
      staticClass: "thumbnail",
      attrs: { id: "thumbnail" + _vm.dir, alt: _vm.dir }
    }),
    _vm._v(" "),
    _vm.techdoc_id != undefined
      ? _c("p", { staticClass: "subtext" }, [_vm._v(_vm._s(_vm.techdoc_id))])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22be8493", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22be8493","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/techdoc.vue
// module id = 827
// module chunks = 0